<template>
  <b-container fluid id="observation-recommendations" class="mt-4">
    <b-row>
      <b-col>
        <div id="alerts" ref="trainer-observations-alert">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            >You have successfully added an observation!</b-alert
          >
          <b-alert :show="showError" dismissible variant="warning">
            Something went wrong. Please refresh and try again, or contact the
            site admin.
          </b-alert>
        </div>
        <div id="recommendation-form">
          <b-row id="headers" class="mt-2 mb-2">
            <b-col>Date</b-col>
            <b-col>School</b-col>
            <b-col>Teacher</b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group labelFor="observation-date">
                <b-form-input
                  name="observation-date"
                  type="date"
                  v-model="dateForm"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="school-select">
                <b-form-select name="school" v-model="schoolForm">
                  <option disabled value>Select a School</option>
                  <option
                    v-for="school in trainerSchools"
                    :key="school.uuid"
                    :value="school.uuid"
                    >{{ school.school_name }}</option
                  >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="teacher-select">
                <b-form-select
                  name="teacher"
                  v-model="teacherForm"
                  :state="teacherInput"
                >
                  <option disabled value>Select a Teacher</option>
                  <option
                    v-for="teacher in schoolTeachers"
                    :key="teacher.uuid"
                    :value="teacher.uuid"
                  >
                    {{ teacher.first_name }} {{ teacher.middle_name }}
                    {{ teacher.last_name }} - head teacher:
                    {{ teacher.head_teacher === true ? "Y" : "N" }}, active:
                    {{ teacher.active === true ? "Y" : "N" }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row id="headers" class="mt-2 mb-2">
            <b-col cols="10">Recommendation</b-col>
            <b-col cols="2">Implemented</b-col>
          </b-row>
          <b-row>
            <b-col cols="10">
              <b-form-textarea
                rows="2"
                max-rows="15"
                type="text"
                id="recommendation"
                v-model="recForm"
              ></b-form-textarea>
            </b-col>
            <b-col cols="2">
              <b-form-radio-group
                name="implemented"
                id="implemented"
                v-model.lazy="impForm"
              >
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-form-group label="Engaged Principal">
                <b-form-radio v-model="engagedPrincipal" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="engagedPrincipal" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Greeted Class">
                <b-form-radio v-model="greet" :value="true">Yes</b-form-radio>
                <b-form-radio v-model="greet" :value="false">No</b-form-radio>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Had Good Attitude">
                <b-form-radio v-model="goodAttitude" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="goodAttitude" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Students' Work Displayed">
                <b-form-radio v-model="workDisplayed" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="workDisplayed" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Play Shop">
                <b-form-radio v-model="playShop" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="playShop" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Nature Box">
                <b-form-radio v-model="natureBox" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="natureBox" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-form-group label="Dress Up Box">
                <b-form-radio v-model="dressUpBox" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="dressUpBox" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Music">
                <b-form-radio v-model="music" :value="true">Yes</b-form-radio>
                <b-form-radio v-model="music" :value="false">No</b-form-radio>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Arts">
                <b-form-radio v-model="arts" :value="true">Yes</b-form-radio>
                <b-form-radio v-model="arts" :value="false">No</b-form-radio>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Reading Corner">
                <b-form-radio v-model="readingCorner" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="readingCorner" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Matching Games">
                <b-form-radio v-model="matchingGames" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="matchingGames" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Puzzles">
                <b-form-radio v-model="puzzles" :value="true">Yes</b-form-radio>
                <b-form-radio v-model="puzzles" :value="false">No</b-form-radio>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Book Making">
                <b-form-radio v-model="bookMaking" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="bookMaking" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Conservation">
                <b-form-radio v-model="conservation" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="conservation" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Gardening">
                <b-form-radio v-model="gardening" :value="true"
                  >Yes</b-form-radio
                >
                <b-form-radio v-model="gardening" :value="false"
                  >No</b-form-radio
                >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Coordinator Present">
                <b-form-radio v-model="coord" :value="true">Yes</b-form-radio>
                <b-form-radio v-model="coord" :value="false">No</b-form-radio>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <gmaps-map v-if="lat" :options="mapOptions" style="height:200px">
                <gmaps-marker :position="{ lat: lat, lng: lng }" />
              </gmaps-map>
              <h3 v-else>No Location Recorded</h3>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-button
                v-if="isAdmin || isSRC"
                align-h="center"
                :variant="'primary'"
                @click="addOrUpdate"
                >{{ buttonTitle }}</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button
                v-if="isAdmin || isSRC"
                align-h="center"
                :variant="'primary'"
                @click="clearForm"
                >Clear</b-button
              >
            </b-col>
          </b-row>
          <h4 class="pt-3">Student Attendance Register</h4>
          <div class="row">
            <div class="col-md-6">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">Student</th>
                    <th scope="col">Status</th>
                    <th scope="col">Class</th>
                  </tr>
                </thead>
                <tr v-for="item in studentRegister" :key="item.uuid">
                  <td>{{ item.student_name }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.name }}</td>
                </tr>
              </table>
            </div>
            <div class="col-md-5">
              <h5>Pictures</h5>
              <div class="row">
                <div class="col-md-6" v-for="item in media" :key="item.uuid">
                  <h6>Type: {{ item.type }}</h6>
                  <img
                    class="img-fluid"
                    :src="'data:image/jpg;base64,' + item.photo"
                    alt=""
                    srcset=""
                  />
                </div>
              </div>
            </div>
          </div>
          <b-row>
            <b-col>
              <b-input-group class="mt-4">
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
              <p class="error text-center" v-if="formError">
                There is an error with your submission. Please ensure all fields
                are completed before submitting
              </p>
              <br />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="table-wrap mt-4">
          <b-table
            v-cloak
            responsive
            small
            :fields="fields"
            :items="obs"
            :striped="true"
            :bordered="true"
            :hover="true"
            :filter="filter"
            :current-page="currentPage"
            @filtered="onFiltered"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            stacked="md"
            id="obs-table"
          >
            <template slot="cell(school_name)" slot-scope="row" v-if="fields">
              <b-link
                :to="{
                  name: 'EditSchool',
                  params: { id: row.item.school_uuid },
                }"
                >{{
                  row.item.school_name.length > 15
                    ? row.item.school_name.slice(0, 15).concat("...")
                    : row.item.school_name
                }}
              </b-link>
            </template>
            <template slot="cell(teacher_name)" slot-scope="row" v-if="fields">
              <b-link
                :to="{
                  name: 'EditTeacher',
                  params: { id: row.item.teacher_uuid },
                }"
                >{{
                  row.item.teacher_name.length > 15
                    ? row.item.teacher_name.slice(0, 15).concat("...")
                    : row.item.teacher_name
                }}</b-link
              >
            </template>
            <template slot="cell(recommendation)" slot-scope="row">
              {{
                row.item.recommendation.length > 15
                  ? row.item.recommendation.slice(0, 15).concat("...")
                  : row.item.recommendation
              }}
            </template>
            <template slot="cell(type)" slot-scope="row">
              {{ (row.item.type) }}
            </template>
            <template slot="cell(created_at)" slot-scope="row">
              {{ setDateTime(row.item.created_at) }}
            </template>
            <template slot="cell(id)" slot-scope="row">
              <b-link @click.stop="editRecommendation(row)">View</b-link>
            </template>
            <template slot="cell(delete)" slot-scope="row">
              <b-link
                v-if="isAdmin || isSRC"
                class="delete"
                @click.stop="deleteObservation(row.item)"
                >Delete</b-link
              >
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="obs.length || 0"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TrainerService from "../services/TrainerService";
import ObservationService from "../services/ObservationService";
import { flash } from "../mixins/flashes";
import { gmapsMap, gmapsMarker } from "x5-gmaps";
import { scrollTo } from "../mixins/scrollTo";
import moment from "moment";

export default {
  name: "TrainerClassroomObservations",
  components: { gmapsMap, gmapsMarker },
  mixins: [flash, scrollTo],
  props: {
    type: String,
  },
  data() {
    return {
      disabled: false,
      required: false,
      changeTitle: false,
      observationId: this.$route.params.id,
      currentPage: 1,
      perPage: 20,
      fields: [
        {
          key: "obs_date",
          label: "Date",
          sortable: true,
        },
        {
          key: "school_name",
          label: "School",
          sortable: true,
        },
        {
          key: "teacher_name",
          label: "Teacher",
          sortable: true,
        },
        {
          key: "recommendation",
          label: "Recommendation",
          sortable: true,
        },
        { key: "type", label: "Observation Type" },
        { key: "created_at", label: "Created At" },
        { key: "id", label: "View/Edit" },
        { key: "delete", label: "" },
      ],
      sortBy: "obs_date",
      sortDesc: true,
      sortDirection: "desc",
      id: "",
      dateForm: null,
      schoolForm: null,
      teacherForm: null,
      recForm: "",
      filter: null,
      impForm: false,
      formError: false,
      totalRows: this.rows,
      engagedPrincipal: false,
      greet: false,
      goodAttitude: false,
      workDisplayed: false,
      playShop: false,
      natureBox: false,
      dressUpBox: false,
      music: false,
      arts: false,
      readingCorner: false,
      matchingGames: false,
      puzzles: false,
      bookMaking: false,
      conservation: false,
      gardening: false,
      coord: false,
      lat: null,
      lng: null,
      mapOptions: {
        center: { lat: null, lng: null },
        zoom: 14,
        fullscreenControl: false,
        mapTypeControl: false,
        rotateControl: false,
        scaleControl: false,
        streetViewControl: false,
      },
      studentRegister: [],
      media: [],
      trainerObservations: [],
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
    }),
    rows() {
      if (this.obs) {
        return this.obs.length;
      }
    },
    buttonTitle() {
      return this.changeTitle ? "Save" : "Submit";
    },
    obs() {
      const data = this.trainerObservations.map((k) => ({
        teacher_name: `${k.first_name} ${k.middle_name} ${k.last_name}`,
        id: k.id,
        implemented: k.implemented,
        obs_date: k.obs_date,
        created_at: k.created_at,
        recommendation: k.recommendation,
        school_uuid: k.school_uuid,
        school_name: k.school_name,
        teacher_uuid: k.teacher_uuid,
        engaged_principal: k.engaged_principal,
        greet: k.greet,
        good_attitude: k.good_attitude,
        work_displayed: k.work_displayed,
        play_shop: k.play_shop,
        nature_box: k.nature_box,
        dress_up_box: k.dress_up_box,
        music: k.music,
        arts: k.arts,
        reading_corner: k.reading_corner,
        matching_games: k.matching_games,
        puzzles: k.puzzles,
        book_making: k.book_making,
        conservation: k.conservation,
        gardening: k.gardening,
        coord: k.coordinator_present,
        lat: k.lat,
        lng: k.lng,
        type: k.type,
        uuid: k.uuid,
      }));
      return data;
    },
    observations: {
      get() {
        return this.$store.state.trainers.observations;
      },
      set(val) {
        this.$store.commit("trainers/observations", val);
      },
    },
    trainerSchools: {
      get() {
        return this.$store.state.trainers.trainerSchoolNames;
      },
    },
    schoolTeachers: {
      get() {
        return this.$store.state.trainers.schoolTeachers;
      },
    },
    teacherInput() {
      !!(this.schoolTeachers && this.schoolTeachers.length);
    },
  },
  methods: {
    ...mapActions({
      GET_SCHOOL_NAMES_BY_TRAINER: "trainers/GET_SCHOOL_NAMES_BY_TRAINER",
      GET_TEACHER_NAMES_BY_TRAINER_SCHOOL:
        "trainers/GET_TEACHER_NAMES_BY_TRAINER_SCHOOL",
      GET_OBSERVATIONS: "trainers/GET_TRAINER_OBSERVATIONS",
      ADD_OBSERVATIONS: "trainers/ADD_TRAINER_OBSERVATIONS",
      UPDATE_OBSERVATIONS: "trainers/UPDATE_TRAINER_OBSERVATIONS",
      GET_TRAINER_SCHOOLS: "schools/GET_TRAINER_SCHOOLS",
      GET_SCHOOL_TEACHERS: "teachers/GET_SCHOOL_TEACHERS",
    }),
    rowClass(item, type) {
      if (item && type === "row") {
        if (item.id === this.id) {
          return "table-success";
        } else {
          return "";
        }
      } else {
        return null;
      }
    },
    setDateTime(timezone) {
      return moment(timezone).format("YYYY/MM/DD, HH:mm");
    },
    async addRecommendation() {
      if (
        this.schoolForm === null ||
        this.teacherForm === null ||
        this.dateForm === null ||
        this.recForm.length === 0
      ) {
        this.formError = true;
        this.flashError();
        return;
      }
      await TrainerService.addTrainerObservation({
        observation_date: this.dateForm,
        trainer_uuid: this.$route.params.id,
        teacher_uuid: this.teacherForm,
        school_uuid: this.schoolForm,
        recommendation: this.recForm,
        implemented: this.impForm,
        engaged_principal: this.engagedPrincipal,
        greet: this.greet,
        good_attitude: this.goodAttitude,
        work_displayed: this.workDisplayed,
        play_shop: this.playShop,
        nature_box: this.natureBox,
        dress_up_box: this.dressUpBox,
        music: this.music,
        arts: this.arts,
        reading_corner: this.readingCorner,
        matching_games: this.matchingGames,
        puzzles: this.puzzles,
        book_making: this.bookMaking,
        conservation: this.conservation,
        gardening: this.gardening,
        coordinator_present: this.coord,
        lat: null,
        lng: null,
      });
      await this.scrollTo("trainer-observations-alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      await this.getTrainerObservationByType(this.type);
    },
    async updateRecommendation() {
      if (
        this.schoolForm === null ||
        this.teacherForm === null ||
        this.dateForm === null ||
        this.recForm.length === 0
      ) {
        this.formError = true;
        this.flashError();
        return;
      }
      await TrainerService.updateTrainerObservation({
        id: this.id,
        observation_date: this.dateForm,
        trainer_uuid: this.$route.params.id,
        teacher_uuid: this.teacherForm,
        school_uuid: this.schoolForm,
        recommendation: this.recForm,
        implemented: this.impForm,
        engaged_principal: this.engagedPrincipal,
        greet: this.greet,
        good_attitude: this.goodAttitude,
        work_displayed: this.workDisplayed,
        play_shop: this.playShop,
        nature_box: this.natureBox,
        dress_up_box: this.dressUpBox,
        music: this.music,
        arts: this.arts,
        reading_corner: this.readingCorner,
        matching_games: this.matchingGames,
        puzzles: this.puzzles,
        book_making: this.bookMaking,
        conservation: this.conservation,
        gardening: this.gardening,
        coordinator_present: this.coord,
      });
      await this.scrollTo("trainer-observations-alert");
      await this.flashSuccess();
      this.clearForm();
      this.formError = false;
      this.changeTitle = false;
      await this.getTrainerObservationByType(this.type);
    },
    async addOrUpdate() {
      if (this.buttonTitle === "Save") {
        this.updateRecommendation();
      } else {
        this.addRecommendation();
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    clearForm() {
      this.dateForm = null;
      this.teacherForm = "";
      this.schoolForm = "";
      this.recForm = "";
      this.impForm = false;
      this.id = "";
      this.engagedPrincipal = false;
      this.greet = false;
      this.goodAttitude = false;
      this.workDisplayed = false;
      this.playShop = false;
      this.natureBox = false;
      this.dressUpBox = false;
      this.music = false;
      this.arts = false;
      this.readingCorner = false;
      this.matchingGames = false;
      this.puzzles = false;
      this.bookMaking = false;
      this.conservation = false;
      this.gardening = false;
      this.coord = false;
      this.lat = null;
      this.lng = null;
      this.mapOptions.center.lat = null;
      this.mapOptions.center.lng = null;
    },
    editRecommendation(row) {
      console.log("row: ", row);
      this.id = row.item.id;
      this.changeTitle = true;
      this.recForm = row.item.recommendation;
      this.impForm = row.item.implemented;
      this.dateForm = row.item.obs_date;
      this.teacherForm = row.item.teacher_uuid;
      this.schoolForm = row.item.school_uuid;
      //this.obs.splice(row.index, 1);
      this.engagedPrincipal = row.item.engaged_principal;
      this.greet = row.item.greet;
      this.goodAttitude = row.item.good_attitude;
      this.workDisplayed = row.item.work_displayed;
      this.playShop = row.item.play_shop;
      this.natureBox = row.item.nature_box;
      this.dressUpBox = row.item.dress_up_box;
      this.music = row.item.music;
      this.arts = row.item.arts;
      this.readingCorner = row.item.reading_corner;
      this.matchingGames = row.item.matching_games;
      this.puzzles = row.item.puzzles;
      this.bookMaking = row.item.book_making;
      this.conservation = row.item.conservation;
      this.gardening = row.item.gardening;
      this.coord = row.item.coord;
      this.lat = row.item.lat;
      this.lng = row.item.lng;
      this.mapOptions.center.lat = row.item.lat;
      this.mapOptions.center.lng = row.item.lng;

      this.getStudentRegister(row.item.uuid);
      this.getObservationMedia(row.item.uuid);
    },
    async deleteObservation(params) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this Observation?"
      );
      if (confirmDelete) {
        await TrainerService.deleteTrainerObservation(params.id);
        await this.getTrainerObservationByType(this.type);
      }
    },
    async getStudentRegister(uuid) {
      ObservationService.fetchStudentRegisterObservation(uuid).then((res) => {
        this.studentRegister = res.data.results;
      });
    },
    async getObservationMedia(uuid) {
      ObservationService.fetchMediaObservation(uuid).then((res) => {
        this.media = res.data.results;
      });
    },
    async getTrainerObservationByType(obsType) {
      TrainerService.fetchTrainerObservationsByType(obsType).then((res) => {
        this.trainerObservations = res.data.observations;
      });
    },
  },
  watch: {
    schoolForm(val) {
      if (val.length > 0) {
        console.log(val);
        this.GET_TEACHER_NAMES_BY_TRAINER_SCHOOL(val);
      }
    },
  },
  mounted() {
    this.getTrainerObservationByType(this.type)
    this.GET_SCHOOL_NAMES_BY_TRAINER();
  },
};
</script>

<style scoped>
#headers,
#date {
  text-align: left;
}
#edit_icon {
  float: left;
}
#delete_icon {
  width: 20%;
}
h1,
#add_icon {
  display: inline;
}
#add_icon {
  width: 3%;
  opacity: 80%;
}
.table {
  table-layout: fixed;
}
.date-row {
  width: 50%;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
.error {
  color: #9e0000;
  text-align: center;
}
th.newclass {
  cursor: pointer;
}
.hover {
  cursor: pointer;
}
</style>
